import {SidebarDeployments as DeploymentsComponent} from '@github-ui/code-view-sidebar/components/SidebarDeployments'
import type {SidebarDeploymentsResponse} from '@github-ui/code-view-sidebar/types'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarDeployments({ownerLogin, repoName}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'deployments', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/deployments`)
      return (await r.json()) as SidebarDeploymentsResponse
    },
  })

  if (!data) return null
  return <DeploymentsComponent {...data} />
}
